var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenVip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u97625",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5FEB\\u52A8\\u753B-\\u9996\\u9875\\u5907\\u4EFD-13",
    transform: "translate(-1101.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9876\\u680F",
    transform: "translate(-2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-50",
    transform: "translate(1103.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-15",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(3.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3601652,11 L3.57545707,11 C2.97663337,11 2.45266263,10.6232877 2.30295671,10.0958904 L0.0573678196,1.73287672 C-0.0923381004,1.28082193 0.0573678196,0.753424663 0.431632628,0.452054794 C0.880750406,0.150684925 1.4795741,0.0753424716 2.00354485,0.37671234 L4.77310448,2.10958904 L6.41986968,0.452054794 C6.71928153,0.150684925 7.09354634,0 7.46781115,0 C7.84207596,0 8.21634079,0.150684925 8.51575263,0.37671234 L10.1625178,2.03424657 L12.9320775,0.301369869 C13.3811952,0 14.0548719,0.0753424716 14.5039897,0.37671234 C14.8782545,0.678082209 15.1028134,1.130137 14.9531075,1.65753425 L12.7075186,10.0205479 C12.4829597,10.6232877 11.9589889,11 11.3601652,11 Z M7.46781115,9.86986301 L11.3601652,9.86986301 C11.5098711,9.86986301 11.5847241,9.79452054 11.5847241,9.71917807 L13.830313,1.35616438 C13.830313,1.35616438 13.830313,1.28082191 13.75546,1.28082193 C13.6806071,1.20547946 13.5309011,1.20547946 13.4560482,1.28082193 L9.93795893,3.46575343 L7.69237004,1.13013699 C7.61751707,1.05479453 7.54266412,1.05479453 7.46781115,1.05479453 C7.39295818,1.05479453 7.31810523,1.05479453 7.24325226,1.13013699 L4.99766337,3.46575343 L1.47957412,1.28082193 C1.3298682,1.20547946 1.18016226,1.28082193 1.18016226,1.28082193 C1.03045634,1.3561644 1.03045634,1.43150685 1.10530929,1.43150685 L3.35089818,9.79452054 C3.35089818,9.86986301 3.42575115,9.94520547 3.57545707,9.94520547 L7.46781115,9.86986301 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65505152,7.6 L5.40611682,7.6 C5.10262148,7.6 4.875,7.38571428 4.875,7.1 C4.875,6.81428572 5.1026215,6.6 5.40611682,6.6 L9.57917768,6.6 C9.88267303,6.6 10.1102945,6.81428572 10.1102945,7.1 C10.1861684,7.3857143 9.95854686,7.6 9.65505152,7.6 Z",
    id: "\\u8DEF\\u5F84"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenVip);
export default __webpack_public_path__ + "static/media/open_vip.cb347c1ced57f274428bd256e39b7ea9.svg";
export { ForwardRef as ReactComponent };